import { render, staticRenderFns } from "./DepositModels.vue?vue&type=template&id=2098e85e&"
import script from "./DepositModels.vue?vue&type=script&lang=js&"
export * from "./DepositModels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports